<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt"><a id="page_2"></a>Publisher: Amy Marson</p>
<p class="copyt">Creative Director: Gailen Runge</p>
<p class="copyt">Editor: Lynn Koolish</p>
<p class="copyt">Technical Editors: Helen Frost and Linda Johnson</p>
<p class="copyt">Cover Designer: Christina Jarumay Fox</p>
<p class="copyt">Book Designers: Kristen Yenche and Kerry Graham</p>
<p class="copyt">Production Coordinator: Tim Manibusan</p>
<p class="copyt">Production Editor: Alice Mace Nakanishi</p>
<p class="copyt">Illustrator: Mary E. Flynn</p>
<p class="copyt">Photo Assistants: Carly Jean Marin and Mai Yong Vang</p>
<p class="copyt">Instructional photography by Diane Pedersen of C&amp;T Publishing, unless otherwise noted</p>
<p class="copyt1">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Copyright.vue?1773c413